import { isString, isPlainObject, isArray, filter, map } from 'lodash';
// create a type guard for the `value` property for each of the ChatMessageValue types
// type guard for the `text` type
export var chatValueIsText = function (value) {
  return isString(value);
};
// type guard for the `entity` type
export var chatValueIsEntity = function (value) {
  return isPlainObject(value) && value !== null && value.hasOwnProperty('name');
};
// type guard for the `entity` type
export var chatValueIsPromptTemplate = function (value) {
  return isPlainObject(value) && value !== null && value.hasOwnProperty('promptTemplateSlug');
};
// type guard for the `entity list` type
export var chatValueIsEntityList = function (value) {
  return isArray(value) && !!filter(value.map(function (item) {
    return chatValueIsEntity(item);
  })).length;
};
// transforms a ChatMessageValue into a string, ready to be submitted to the server
export var chatValueSerialize = function (value) {
  if (chatValueIsText(value)) {
    return value;
  }
  if (chatValueIsEntity(value)) {
    return value.name;
  }
  if (chatValueIsEntityList(value)) {
    return value.map(function (entity) {
      return "".concat(entity.name, ")");
    }).join(', ');
  }
};
// transforms a ChatMessageDefinition into a string, ready to be submitted to the server
export var chatMessageSerialize = function (message) {
  return map(message.values, function (value) {
    return chatValueSerialize(value);
  }).join(' ');
};